// extracted by mini-css-extract-plugin
export default {"ButtonsPopup":"ButtonsPopup_ButtonsPopup__Kehyc"};